import forge from 'node-forge';
import { post } from '../api';
import { generateAES256Key, encryptAESKeyWithRSAPublicKey } from './paymentCrypto';

// Purpose-built endpoints for the /update-customer-orders page. The contact is resolved
// server-side from the verified JWT, so the client never sends a contact id for these.

export const getOrders = (orderIds) => post('custom/getOrdersForUpdate', { orderIds });

export const getPaymentMethods = () => post('custom/getOrderPaymentMethods', {});

export const updateOrdersPaymentMethod = (orderIds, paymentMethodId) => post('custom/updateOrdersPaymentMethod', { orderIds, paymentMethodId });

export const tokenizeAndUpdateOrders = (data, orderIds) => post('custom/tokenizeAndUpdateOrders', { data, orderIds });

export const payNowOrder = (orderId) => post('custom/payNowOrder', { orderId });

// Server-side Chargent Sale for a single order: pass an existing saved card (paymentMethodId)
// OR a new card (data = the encrypted card payload). Exactly one is provided.
export const payOrder = (orderId, paymentMethodId, data) => post('custom/payOrder', { orderId, paymentMethodId, data });

// Reuses the portal's proven PortalAPIService.updatedContent: tokenizes the card and sets it as
// the order's default card (including the Account-touch that makes Chargent re-sync the order's
// card fields). Used after a successful pay-now to save the new card on the order. memberId is the
// logged-in contact id (the contact the browser established the encryption key on).
export const updateOrderCard = (memberId, data, orderId) => post('custom/updatedContent', { memberId, data, selectedOrderId: orderId });

// Key exchange reuses the existing Amplify-only endpoints (not Salesforce methods):
// fetch the RSA public key, generate an AES key, send it back wrapped, and return the AES
// key for encrypting the card. memberId is the contact id.
export const establishCardKey = async (memberId) => {
    const keyResult = await post('custom/getKeyContent', { memberId });
    if (!keyResult?.isSuccess || !keyResult?.data) {
        return null;
    }
    const aesKey = generateAES256Key();
    const encryptedAESKey = encryptAESKeyWithRSAPublicKey(aesKey, forge.util.decode64(keyResult.data));
    await post('custom/setKeyContent', { memberId, key: forge.util.encode64(encryptedAESKey) });
    return aesKey;
};
